import * as React from 'react';
import Paper, { PaperProps } from '@mui/material/Paper';

export const WrapperDialog: React.JSXElementConstructor<PaperProps> = ({
  children,
}: PaperProps) => {
  return (
    <Paper
      sx={{
        padding: '30px',
        width: '100%',
        maxWidth: '633px',
        borderRadius: '15px',
        margin: '40px auto',
      }}
    >
      {children}
    </Paper>
  );
};

export const WrapperDialogLarge: React.JSXElementConstructor<PaperProps> = ({
  children,
}: PaperProps) => {
  return (
    <Paper
      sx={{
        padding: '37px 25px;',
        width: '100%',
        maxWidth: '876px',
        minHeight: '715px',
        borderRadius: '15px',
        margin: '40px auto',
      }}
    >
      {children}
    </Paper>
  );
};

export const WrapperDialogSmall: React.JSXElementConstructor<PaperProps> = ({
  children,
}: PaperProps) => {
  return (
    <Paper
      sx={{
        padding: '30px',
        width: '100%',
        maxWidth: '479px',
        borderRadius: '15px',
        margin: '40px auto',
      }}
    >
      {children}
    </Paper>
  );
};
